import React from 'react';
import { useLocation } from 'react-router-dom';
import { DateType } from '../../Analytics/types';

interface AdsUrlVariables {
  clientId?: string;
  startDate?: string;
  endDate?: string;
  dateType: DateType;
  showNonAttributedData: boolean;
}

interface UseUrlInitializationProps {
  clientId?: string;
  clientCreatedDate?: string;
  defaultDateType: DateType;
  defaultShowNonAttributedData: boolean;
  updateUrlParams: (params: AdsUrlVariables) => void;
}

export const useUrlInitialization = ({
  clientId,
  clientCreatedDate,
  defaultDateType,
  defaultShowNonAttributedData,
  updateUrlParams,
}: UseUrlInitializationProps) => {
  const location = useLocation();

  // Initialize URL params if they don't exist
  React.useEffect(() => {
    if (!location.search && clientId && clientCreatedDate) {
      const initialVariables: AdsUrlVariables = {
        clientId,
        dateType: defaultDateType,
        showNonAttributedData: defaultShowNonAttributedData,
      };
      updateUrlParams(initialVariables);
    }
  }, [location.search, updateUrlParams, clientId, clientCreatedDate, defaultDateType, defaultShowNonAttributedData]);
};
